<div class="container-fluid bg-dark px-0">
  <div class="w-100 p-4" style="background-color: #484E52;">
    <div class="row">
      <!-- Visible solo en Smartphone -->
      <div class="d-block d-lg-none">
        <div class="col-lg-12 mb-4">
          <div class="card border">
            <div class="card-body p-0">
              <div class="row">
                <div class="col-lg-3">
                  <!-- Visible solo en Desktop -->
                  <div *ngIf="activeLang == 'es'" class="border-right p-4 f-20 d-none d-lg-block">
                    <strong>{{ 'IL_PRECIO_ACCION_DE' | translate }} {{razonSocial}}</strong>
                  </div>
                  <div *ngIf="activeLang == 'en'" class="border-right p-4 f-20 d-none d-lg-block">
                    {{razonSocial}} {{ 'IL_PRECIO_ACCION_DE' | translate }}
                  </div>
                  <!-- Visible solo en mobile -->
                  <div *ngIf="activeLang == 'es'" class="p-2 f-18 d-block d-lg-none">
                    {{ 'IL_PRECIO_ACCION_DE' | translate }} {{razonSocial}}
                  </div>
                  <div *ngIf="activeLang == 'en'" class="p-2 f-18 d-block d-lg-none">
                    {{razonSocial}} {{ 'IL_PRECIO_ACCION_DE' | translate }}
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="row m-1">
                    <div class="col-6 col-sm-3 border-bottom p-2">
                      <span class="text-muted text-uppercase">{{ 'IL_PRECIO_ACTUAL' | translate }}</span>
                      <h4 class="text-secondary font-weight-bold f-22 mb-0">{{(precioCierre ? precioCierre : 0) |
                        numberFormat}} CLP</h4>
                    </div>
                    <div class="col-6 col-sm-3 border-bottom p-2">
                      <span class="text-muted text-uppercase">{{ 'IL_PRECIO_MAYOR' | translate }}</span>
                      <h4 class="text-secondary font-weight-bold f-22 mb-0">{{(precioMayor ? precioMayor : 0) |
                        numberFormat}} CLP</h4>
                    </div>
                    <div class="col-6 col-sm-3 border-bottom p-2">
                      <span class="text-muted text-uppercase">{{ 'IL_PRECIO_MENOR' | translate }}</span>
                      <h4 class="text-secondary font-weight-bold f-22 mb-0">{{(precioMenor ? precioMenor : 0) |
                        numberFormat}} CLP</h4>
                    </div>
                    <div class="col-6 col-sm-3 border-bottom p-2">
                      <span class="text-muted text-uppercase">{{ 'IL_VARIACION' | translate }} ({{'TYPE_CHANGE' |
                        translate}})</span>
                      <h4
                        [ngClass]="{'text-danger' : variacion < 0, 'text-secondary' : variacion === 0, 'text-success' : variacion > 0}"
                        class="font-weight-bold f-22 mb-0">
                        {{(variacion ? variacion : 0) | numberFormat}}%</h4>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 p-4 text-center">
                  <a href="https://www.bolsadesantiago.com/resumen_instrumento/PAMPA" target="blank_"
                    class="btn btn-success border">
                    {{ 'IL_VER_BOLSA' | translate }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Visible solo en Desktop -->
      <div class="d-none d-lg-block w-100">
        <div class="col-lg-12">
          <div class="card bg-white">
            <div class="card-body p-0">
              <div class="d-flex align-items-center">
                <div *ngIf="activeLang == 'es'" class="flex-fill p-4 f-20" style="width: 240px;">
                  {{ 'IL_PRECIO_ACCION_DE' | translate }} {{razonSocial}}
                </div>
                <div *ngIf="activeLang == 'en'" class="flex-fill p-4 f-20" style="width: 240px;">
                  {{razonSocial}} {{ 'IL_PRECIO_ACCION_DE' | translate }}
                </div>
                <div class="flex-fill border-right px-4">
                  <span class="text-muted text-uppercase">{{ 'IL_PRECIO_ACTUAL' | translate }}</span>
                  <h4 class="text-secondary font-weight-bold f-22 mb-0">{{(precioCierre ? precioCierre : 0) |
                    numberFormat}} CLP</h4>
                </div>
                <div class="flex-fill border-right px-4">
                  <span class="text-muted text-uppercase">{{ 'IL_PRECIO_MAYOR' | translate }}</span>
                  <h4 class="text-secondary font-weight-bold f-22 mb-0">{{(precioMayor ? precioMayor : 0) |
                    numberFormat}} CLP</h4>
                </div>
                <div class="flex-fill border-right px-4">
                  <span class="text-muted text-uppercase">{{ 'IL_PRECIO_MENOR' | translate }}</span>
                  <h4 class="text-secondary font-weight-bold f-22 mb-0">{{(precioMenor ? precioMenor : 0) |
                    numberFormat}} CLP</h4>
                </div>
                <div class="flex-fill border-right px-4">
                  <span class="text-muted text-uppercase">{{ 'IL_VARIACION' | translate }} ({{'TYPE_CHANGE' |
                    translate}})</span>
                  <h4
                    [ngClass]="{'text-danger' : variacion < 0, 'text-secondary' : variacion === 0, 'text-success' : variacion > 0}"
                    class="font-weight-bold f-22 mb-0">
                    {{(variacion ? variacion : 0) | numberFormat}}%</h4>
                </div>
                <div class="flex-fill text-center">
                  <a href="https://www.bolsadesantiago.com/resumen_instrumento/PAMPA" target="blank_"
                    class="btn btn-success border">
                    {{ 'IL_VER_BOLSA' | translate }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div style="text-align: right; margin-right: 2%; margin-bottom: 1%">
  <button style="border: none;outline:none; margin-top: 1%;" [ngClass]="{'test': activeLang == 'es'}"
    (click)="cambiarLenguaje('es')" class="text-secondary" target="blank_">{{ 'IL_LENGUAJE_ES' |
    translate }}</button>
  &nbsp;|&nbsp;
  <button style="border: none;outline: none;" [ngClass]="{'test': activeLang == 'en'}" (click)="cambiarLenguaje('en')"
    class="text-secondary" target="blank_">{{ 'IL_LENGUAJE_EN' |
    translate }}</button>
</div>

<div class="container-fluid bg-dark px-0">
  <div class="w-100 p-4 bg-white">
    <div class="row">
      <div class="col-lg-9 mb-4">
        <div class="card bg-white">
          <span class="d-block mb-3 text-dark"
            style="font-size: 26px; font-weight: 300"><strong>{{nemoSasa}}</strong></span>
          <div class="card-body p-2">
            <div id="chart-line-prices"></div>
          </div>
        </div>
      </div>

      <!-- Versión Desktop -->
      <div class="col-lg-3 mb-4 d-none d-lg-block">
        <span class="d-block mb-3 text-dark" style="font-size: 26px; font-weight: 300"><strong>{{ 'IL_COTIZACION' |
            translate
            }}</strong></span>
        <div class="card-body h-100 px-0 py-1">
          <ul class="list-group bg-white" style="line-height: normal">
            <li class="list-group-item pt-3">
              <span class="f-14 d-block text-muted text-uppercase">{{ 'IL_VALOR' | translate }}</span>
              <span class="f-40 text-secondary">{{(precioCierre ? precioCierre : 0)| numberFormat}} CLP</span>
            </li>
            <li class="list-group-item">
              <span class="f-14 d-block text-muted text-uppercase">{{ 'IL_VARIACION' | translate }} ({{'TYPE_CHANGE' |
                translate}})</span>
              <span
                [ngClass]="{'text-danger' : variacion < 0, 'text-secondary' : variacion === 0, 'text-success' : variacion > 0}"
                class="f-40">{{(variacion ? variacion :
                0) | numberFormat}}%</span>
            </li>
            <li class="list-group-item">
              <span class="f-14 d-block text-muted text-uppercase">{{ 'IL_ULTIMA_ACTUALIZACION' | translate }}</span>
              <span class="f-40 text-secondary">{{ultimaActualizacionFecha | date: "HH:mm"}}</span>
            </li>
          </ul>
        </div>
      </div>
      <!-- Versión mobile -->
      <div class="d-block d-lg-none w-100">
        <div class="col-lg-12 mb-4">
          <span class="d-block mb-3 text-muted" style="font-size: 26px; font-weight: 300"><strong>{{ 'IL_COTIZACION' |
              translate
              }}</strong></span>
          <div class="card-body px-0 py-1" style="line-height: normal">
            <ul class="list-group list-group-horizontal bg-white" style="line-height: normal">
              <li class="list-group-item flex-fill p-2">
                <span class="f-10 d-block text-muted text-uppercase">{{ 'IL_VALOR' | translate }}</span>
                <span class="f-30 text-secondary">{{(precioCierre ? precioCierre : 0) | numberFormat}}</span>
              </li>
              <li class="list-group-item flex-fill p-2">
                <span class="f-10 d-block text-muted text-uppercase">{{ 'IL_VARIACION' | translate }}</span>
                <span
                  [ngClass]="{'text-danger' : variacion < 0, 'text-secondary' : variacion === 0, 'text-success' : variacion > 0}"
                  class="f-30">{{(variacion ?
                  variacion : 0) | numberFormat}}%</span>
              </li>
              <li class="list-group-item flex-fill p-2">
                <span class="f-10 d-block text-muted text-uppercase">{{ 'IL_ULTIMA_ACTUALIZACION' | translate }}</span>
                <span class="f-30 text-secondary">{{ultimaActualizacionFecha | date: "HH:mm"}}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

<div class="container-fluid bg-dark px-0">
  <div class="w-100 p-4 bg-white">
    <div class="row mb-4">
      <div class="col-lg-4 mb-3">
        <span class="d-block mb-3 text-dark" style="font-size: 26px; font-weight: 300"> <strong>{{
            'IL_ULTIMAS_TRANSACCIONES' |
            translate }}</strong></span>
        <div class="card bg-white border rounded">
          <div class="card-body  p-0" style="overflow: auto">
            <div class="card-body">
              <table class="table mb-0 w-100">
                <thead>
                  <tr>
                    <th scope="col">{{ 'IL_HORA' | translate }}</th>
                    <th scope="col" class="text-right">{{ 'IL_CANTIDAD' | translate }}</th>
                    <th scope="col" class="text-right">{{ 'IL_PRECIO' | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let transaccion of ultimasTransacciones">
                    <td>{{transaccion.HORA2 | date: "HH:mm:ss"}}</td>
                    <td *ngIf="activeLang == 'es'" class="text-right">{{transaccion.CANTIDAD | numberFormat}}</td>
                    <td *ngIf="activeLang == 'en'" class="text-right">{{transaccion.CANTIDAD | number: '1.2-2'}}</td>
                    <td *ngIf="activeLang == 'es'" class="text-right">{{transaccion.PRECIO | numberFormat}} CLP</td>
                    <td *ngIf="activeLang == 'en'" class="text-right">{{transaccion.PRECIO | number: '1.2-2'}} CLP</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>



      <div class="col-lg-8 mb-4">
        <span class="d-block mb-3 text-dark" style="font-size: 26px; font-weight: 300"><strong>{{ 'IL_RESUMEN_PRECIOS' |
            translate }}</strong></span>
        <div class="card bg-white border rounded">
          <div class="card-body  p-0" style="overflow: auto">
            <div class="card-body">
              <table class="table mb-0 w-100">
                <thead>
                  <tr>
                    <th scope="col"></th>
                    <th scope="col" class="text-right">{{ 'IL_HOY' | translate }}</th>
                    <th scope="col" class="text-right">{{ 'IL_AYER' | translate }}</th>
                    <th scope="col" class="text-right">{{ 'IL_MES_ACTUAL' | translate }}</th>
                    <th scope="col" class="text-right">{{ 'IL_ANNO_ACTUAL' | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ 'IL_MONTO' | translate }} ($)</td>
                    <td *ngIf="activeLang == 'es'" class="text-right">{{(precioHoy.monto ? precioHoy.monto : 0) |
                      numberFormat }} CLP</td>
                    <td *ngIf="activeLang == 'en'" class="text-right">{{(precioHoy.monto ? precioHoy.monto : 0) |
                      number:
                      '1.2-2' }} CLP</td>
                    <td *ngIf="activeLang == 'es'" class="text-right">{{(precioAyer.monto ? precioAyer.monto : 0) |
                      numberFormat}} CLP</td>
                    <td *ngIf="activeLang == 'en'" class="text-right">{{(precioAyer.monto ? precioAyer.monto : 0) |
                      number: '1.2-2'}} CLP</td>
                    <td *ngIf="activeLang == 'es'" class="text-right">{{(precioMes.monto ? precioMes.monto : 0) |
                      numberFormat}} CLP</td>
                    <td *ngIf="activeLang == 'en'" class="text-right">{{(precioMes.monto ? precioMes.monto : 0) |
                      number:
                      '1.2-2'}} CLP</td>
                    <td *ngIf="activeLang == 'es'" class="text-right">{{(precioAno.monto ? precioAno.monto : 0) |
                      numberFormat}}</td>
                    <td *ngIf="activeLang == 'en'" class="text-right">{{(precioAno.monto ? precioAno.monto : 0) |
                      number:
                      '1.2-2'}} CLP</td>
                  </tr>
                  <tr>
                    <td>{{ 'IL_MAYOR' | translate }}</td>
                    <td *ngIf="activeLang == 'es'" class="text-right">{{(precioHoy.pre_may ? precioHoy.pre_may : 0) |
                      numberFormat}} CLP</td>
                    <td *ngIf="activeLang == 'en'" class="text-right">{{(precioHoy.pre_may ? precioHoy.pre_may : 0) |
                      number: '1.2-2'}} CLP</td>
                    <td *ngIf="activeLang == 'es'" class="text-right">{{(precioAyer.pre_may ? precioAyer.pre_may : 0) |
                      numberFormat}} CLP</td>
                    <td *ngIf="activeLang == 'en'" class="text-right">{{(precioAyer.pre_may ? precioAyer.pre_may : 0) |
                      number: '1.2-2'}} CLP</td>
                    <td *ngIf="activeLang == 'es'" class="text-right">{{(precioMes.pre_may ? precioMes.pre_may : 0) |
                      numberFormat}} CLP</td>
                    <td *ngIf="activeLang == 'en'" class="text-right">{{(precioMes.pre_may ? precioMes.pre_may : 0) |
                      number: '1.2-2'}} CLP</td>
                    <td *ngIf="activeLang == 'es'" class="text-right">{{(precioAno.pre_may ? precioAno.pre_may : 0) |
                      numberFormat}} CLP</td>
                    <td *ngIf="activeLang == 'en'" class="text-right">{{(precioAno.pre_may ? precioAno.pre_may : 0) |
                      number: '1.2-2'}} CLP</td>
                  </tr>
                  <tr>
                    <td>{{ 'IL_MENOR' | translate }}</td>
                    <td *ngIf="activeLang == 'es'" class="text-right">{{(precioHoy.pre_men ? precioHoy.pre_men : 0) |
                      numberFormat}} CLP</td>
                    <td *ngIf="activeLang == 'en'" class="text-right">{{(precioHoy.pre_men ? precioHoy.pre_men : 0) |
                      number: '1.2-2'}} CLP</td>
                    <td *ngIf="activeLang == 'es'" class="text-right">{{(precioAyer.pre_men ? precioAyer.pre_men : 0) |
                      numberFormat}} CLP</td>
                    <td *ngIf="activeLang == 'en'" class="text-right">{{(precioAyer.pre_men ? precioAyer.pre_men : 0) |
                      number: '1.2-2'}} CLP</td>
                    <td *ngIf="activeLang == 'es'" class="text-right">{{(precioMes.pre_men ? precioMes.pre_men : 0) |
                      numberFormat}} CLP</td>
                    <td *ngIf="activeLang == 'en'" class="text-right">{{(precioMes.pre_men ? precioMes.pre_men : 0) |
                      number: '1.2-2'}} CLP</td>
                    <td *ngIf="activeLang == 'es'" class="text-right">{{(precioAno.pre_men ? precioAno.pre_men : 0) |
                      numberFormat}} CLP</td>
                    <td *ngIf="activeLang == 'en'" class="text-right">{{(precioAno.pre_men ? precioAno.pre_men : 0) |
                      number: '1.2-2'}} CLP</td>
                  </tr>
                  <tr>
                    <td>{{ 'IL_ULTIMO' | translate }}</td>
                    <td *ngIf="activeLang == 'es'" class="text-right">{{(precioHoy.pre_cie ? precioHoy.pre_cie : 0) |
                      numberFormat}} CLP</td>
                    <td *ngIf="activeLang == 'en'" class="text-right">{{(precioHoy.pre_cie ? precioHoy.pre_cie : 0) |
                      number: '1.2-2'}} CLP</td>
                    <td *ngIf="activeLang == 'es'" class="text-right">{{(precioAyer.pre_cie ? precioAyer.pre_cie : 0) |
                      numberFormat}} CLP</td>
                    <td *ngIf="activeLang == 'en'" class="text-right">{{(precioAyer.pre_cie ? precioAyer.pre_cie : 0) |
                      number: '1.2-2'}} CLP</td>
                    <td *ngIf="activeLang == 'es'" class="text-right">{{(precioMes.pre_cie ? precioMes.pre_cie : 0) |
                      numberFormat}} CLP</td>
                    <td *ngIf="activeLang == 'en'" class="text-right">{{(precioMes.pre_cie ? precioMes.pre_cie : 0) |
                      number: '1.2-2'}} CLP</td>
                    <td *ngIf="activeLang == 'es'" class="text-right">{{(precioAno.pre_cie ? precioAno.pre_cie : 0) |
                      numberFormat}} CLP</td>
                    <td *ngIf="activeLang == 'en'" class="text-right">{{(precioAno.pre_cie ? precioAno.pre_cie : 0) |
                      number: '1.2-2'}} CLP</td>
                  </tr>
                  <tr>
                    <td>{{ 'IL_V' | translate }}(%)</td>
                    <td *ngIf="activeLang == 'es'" class="text-right"
                      [ngClass]="{'text-danger' : precioHoy.var_cie < 0, 'text-secondary' : precioHoy.var_cie >= 0}">
                      {{(precioHoy.var_cie ? precioHoy.var_cie : 0) | numberFormat}}</td>
                    <td *ngIf="activeLang == 'en'" class="text-right"
                      [ngClass]="{'text-danger' : precioHoy.var_cie < 0, 'text-secondary' : precioHoy.var_cie >= 0}">
                      {{(precioHoy.var_cie ? precioHoy.var_cie : 0) | number: '1.2-2'}}</td>
                    <td *ngIf="activeLang == 'es'" class="text-right"
                      [ngClass]="{'text-danger' : precioAyer.var_cie < 0, 'text-secondary' : precioAyer.var_cie >= 0}">
                      {{(precioAyer.var_cie ? precioAyer.var_cie : 0) | numberFormat}}</td>
                    <td *ngIf="activeLang == 'en'" class="text-right"
                      [ngClass]="{'text-danger' : precioAyer.var_cie < 0, 'text-secondary' : precioAyer.var_cie >= 0}">
                      {{(precioAyer.var_cie ? precioAyer.var_cie : 0) | number: '1.2-2'}}</td>
                    <td *ngIf="activeLang == 'es'" class="text-right"
                      [ngClass]="{'text-danger' : precioMes.var_cie < 0, 'text-secondary' : precioMes.var_cie >= 0}">
                      {{(precioMes.var_cie ? precioHoy.var_cie : 0) | numberFormat}}</td>
                    <td *ngIf="activeLang == 'en'" class="text-right"
                      [ngClass]="{'text-danger' : precioMes.var_cie < 0, 'text-secondary' : precioMes.var_cie >= 0}">
                      {{(precioMes.var_cie ? precioHoy.var_cie : 0) | number: '1.2-2'}}</td>
                    <td *ngIf="activeLang == 'es'" class="text-right"
                      [ngClass]="{'text-danger' : precioAno.var_cie < 0, 'text-secondary' : precioAno.var_cie >= 0}">
                      {{(precioAno.var_cie ? precioAno.var_cie : 0) | numberFormat}}</td>
                    <td *ngIf="activeLang == 'en'" class="text-right"
                      [ngClass]="{'text-danger' : precioAno.var_cie < 0, 'text-secondary' : precioAno.var_cie >= 0}">
                      {{(precioAno.var_cie ? precioAno.var_cie : 0) | number: '1.2-2'}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



<!-- <div class="container-fluid bg-dark px-0">
  <div class="w-100 p-4 bg-white">
    <div class="row mb-4">
      <div class="col-lg-6 mb-4">
        <span class="d-block mb-3 text-dark" style="font-size: 26px; font-weight: 300"><strong>{{ 'IL_RENTABILIDAD' |
            translate
            }}</strong></span>
        <div class="card bg-white border rounded">
          <div class="card-body  p-0" style="overflow: auto">
            <div class="card-body">
              <table class="table mb-0 w-100">
                <thead>
                  <tr>
                    <th scope="col">{{ 'IL_RENTABILIDAD' | translate }}</th>
                    <th scope="col" class="text-right">(%)</th>
                  </tr>
                </thead>
                <tbody class="border-0 k-listview">
                  <tr>
                    <td>{{ 'IL_MES_ACTUAL' | translate }}</td>
                    <td *ngIf="activeLang == 'es'" class="text-right"
                      [ngClass]="{'text-danger' : mesActual < 0, 'text-secondary' : mesActual >= 0}">
                      {{mesActual |
                      numberFormat}}</td>
                    <td *ngIf="activeLang == 'en'" class="text-right"
                      [ngClass]="{'text-danger' : mesActual < 0, 'text-secondary' : mesActual >= 0}">
                      {{mesActual |
                      number: '1.2-2'}}</td>
                  </tr>
                  <tr>
                    <td>{{ 'IL_MES_ANTERIOR' | translate }}</td>
                    <td *ngIf="activeLang == 'es'" class="text-right"
                      [ngClass]="{'text-danger' : mesAnterior < 0, 'text-secondary' : mesAnterior >= 0}">{{mesAnterior |
                      numberFormat}}</td>
                    <td *ngIf="activeLang == 'en'" class="text-right"
                      [ngClass]="{'text-danger' : mesAnterior < 0, 'text-secondary' : mesAnterior >= 0}">{{mesAnterior |
                      number: '1.2-2'}}</td>
                  </tr>
                  <tr>
                    <td>{{ 'IL_ANNO_ACTUAL' | translate }}</td>
                    <td *ngIf="activeLang == 'es'" class="text-right"
                      [ngClass]="{'text-danger' : anoActual < 0, 'text-secondary' : anoActual >= 0}">
                      {{anoActual | numberFormat}}</td>
                    <td *ngIf="activeLang == 'en'" class="text-right"
                      [ngClass]="{'text-danger' : anoActual < 0, 'text-secondary' : anoActual >= 0}">
                      {{anoActual | number: '1.2-2'}}</td>
                  </tr>
                  <tr>
                    <td>{{ 'IL_ANNO_ANTERIOR' | translate }}</td>
                    <td *ngIf="activeLang == 'es'" class="text-right"
                      [ngClass]="{'text-danger' : anoAnterior < 0, 'text-secondary' : anoAnterior >= 0}">{{anoAnterior |
                      numberFormat}}</td>
                    <td *ngIf="activeLang == 'en'" class="text-right"
                      [ngClass]="{'text-danger' : anoAnterior < 0, 'text-secondary' : anoAnterior >= 0}">{{anoAnterior |
                      number: '1.2-2'}}</td>
                  </tr>
                  <tr>
                    <td>{{ 'IL_ANNO_7_DIAS' | translate }}</td>
                    <td *ngIf="activeLang == 'es'" class="text-right"
                      [ngClass]="{'text-danger' : ano7Dias < 0, 'text-secondary' : ano7Dias >= 0}">
                      {{ano7Dias | numberFormat}}</td>
                    <td *ngIf="activeLang == 'en'" class="text-right"
                      [ngClass]="{'text-danger' : ano7Dias < 0, 'text-secondary' : ano7Dias >= 0}">
                      {{ano7Dias | number: '1.2-2'}}</td>
                  </tr>
                  <tr>
                    <td>{{ 'IL_30_DIAS' | translate }}</td>
                    <td *ngIf="activeLang == 'es'" class="text-right"
                      [ngClass]="{'text-danger' : dias30 < 0, 'text-secondary' : dias30 >= 0}">
                      {{dias30 | numberFormat}}</td>
                    <td *ngIf="activeLang == 'en'" class="text-right"
                      [ngClass]="{'text-danger' : dias30 < 0, 'text-secondary' : dias30 >= 0}">
                      {{dias30 | number: '1.2-2'}}</td>
                  </tr>
                  <tr>
                    <td>{{ 'IL_52_SEMANAS' | translate }}</td>
                    <td *ngIf="activeLang == 'es'" class="text-right"
                      [ngClass]="{'text-danger' : semanas52 < 0,  'text-secondary' : semanas52 >= 0}">{{semanas52 |
                      numberFormat}}</td>
                    <td *ngIf="activeLang == 'en'" class="text-right"
                      [ngClass]="{'text-danger' : semanas52 < 0,  'text-secondary' : semanas52 >= 0}">{{semanas52 |
                      number: '1.2-2'}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div> -->

      <!-- <div class="col-lg-6 mb-4">
        <span class="d-block mb-3 text-dark" style="font-size: 26px; font-weight: 300"><strong>Ratios</strong></span>
        <div class="card bg-white border rounded">
          <div class="card-body  p-0" style="overflow: auto">
            <div class="card-body">
              <table class="table mb-0 w-100">
                <thead>
                  <tr>
                    <th scope="col">Ratio</th>
                    <th scope="col" class="text-right">{{'IL_VALOR' | translate}} {{nemoSasa}}</th>
                    <th scope="col" class="text-right">{{'IL_VALOR' | translate}} IPSA</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ 'IL_PRES_BURSATIL' | translate }}</td>
                    <td *ngIf="activeLang == 'es'" class="text-right">{{presBursatil | numberFormat}} %</td>
                    <td *ngIf="activeLang == 'en'" class="text-right">{{presBursatil | number: '1.2-2'}} %</td>
                    <td *ngIf="activeLang == 'es'" class="text-right">{{presBursatilIPSA | numberFormat}} %</td>
                    <td *ngIf="activeLang == 'en'" class="text-right">{{presBursatilIPSA | number: '1.2-2'}} %</td>
                  </tr>
                  <tr>
                    <td>{{ 'IL_UTILIDAD_PRECIO' | translate }}</td>
                    <td *ngIf="activeLang == 'es'" class="text-right">{{utilidadPrecio | numberFormat}} </td>
                    <td *ngIf="activeLang == 'en'" class="text-right">{{utilidadPrecio | number: '1.2-2'}} </td>
                    <td *ngIf="activeLang == 'es'" class="text-right">{{utilidadPrecioIPSA | numberFormat}} </td>
                    <td *ngIf="activeLang == 'en'" class="text-right">{{utilidadPrecioIPSA | number: '1.2-2'}} </td>
                  </tr>
                  <tr>
                    <td>{{ 'IL_PRECIO_UTILIDAD' | translate }}</td>
                    <td *ngIf="activeLang == 'es'" class="text-right">{{precioUtilidad | numberFormat}} </td>
                    <td *ngIf="activeLang == 'en'" class="text-right">{{precioUtilidad | number: '1.2-2'}} </td>
                    <td *ngIf="activeLang == 'es'" class="text-right">{{precioUtilidadIPSA | numberFormat}} </td>
                    <td *ngIf="activeLang == 'en'" class="text-right">{{precioUtilidadIPSA | number: '1.2-2'}} </td>
                  </tr>
                  <tr>
                    <td>{{ 'IL_LIBRO_AJUSTADO' | translate }}</td>
                    <td *ngIf="activeLang == 'es'" class="text-right">{{valorLibroAjustado | numberFormat}} </td>
                    <td *ngIf="activeLang == 'en'" class="text-right">{{valorLibroAjustado | number: '1.2-2'}} </td>
                    <td *ngIf="activeLang == 'es'" class="text-right">{{valorLibroAjustadoIPSA | numberFormat}} </td>
                    <td *ngIf="activeLang == 'en'" class="text-right">{{valorLibroAjustadoIPSA | number: '1.2-2'}}
                    </td>
                  </tr>
                  <tr>
                    <td>{{ 'IL_BOLSA_LIBRO' | translate }}</td>
                    <td *ngIf="activeLang == 'es'" class="text-right">{{bolsaLibroValue | numberFormat}} </td>
                    <td *ngIf="activeLang == 'en'" class="text-right">{{bolsaLibroValue | number: '1.2-2'}} </td>
                    <td *ngIf="activeLang == 'es'" class="text-right">{{bolsaLibroValueIPSA | numberFormat}} </td>
                    <td *ngIf="activeLang == 'en'" class="text-right">{{bolsaLibroValueIPSA | number: '1.2-2'}} </td>
                  </tr>
                  <tr>
                    <td>ROE</td>
                    <td *ngIf="activeLang == 'es'" class="text-right">{{roe | numberFormat}} %</td>
                    <td *ngIf="activeLang == 'en'" class="text-right">{{roe | number: '1.2-2'}} %</td>
                    <td *ngIf="activeLang == 'es'" class="text-right">{{roeIPSA | numberFormat}} %</td>
                    <td *ngIf="activeLang == 'en'" class="text-right">{{roeIPSA | number: '1.2-2'}} %</td>
                  </tr>
                  <tr>
                    <td>{{ 'IL_VENTAS_ACTIVOS' | translate }}</td>
                    <td *ngIf="activeLang == 'es'" class="text-right">{{ventasActivos | numberFormat}} </td>
                    <td *ngIf="activeLang == 'en'" class="text-right">{{ventasActivos | number: '1.2-2'}} </td>
                    <td *ngIf="activeLang == 'es'" class="text-right">{{ventasActivosIPSA | numberFormat}} </td>
                    <td *ngIf="activeLang == 'en'" class="text-right">{{ventasActivosIPSA | number: '1.2-2'}} </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div> -->
      <!-- <div class="col-lg-6 mb-6">
        <span class="d-block mb-3 text-dark" style="font-size: 26px; font-weight: 300"><strong>{{
            'IL_PRECIOS_52_SEMANAS' |
            translate }}</strong></span>
        <div class="card bg-white border rounded">
          <div class="card-body  p-0" style="overflow: auto">
            <div class="card-body">
              <table class="table mb-0 w-100">
                <thead>
                  <tr>
                    <th scope="col">{{ 'IL_MAXIMO' | translate }} {{nemoSasa}}</th>
                    <th scope="col">{{ 'IL_MAXIMO' | translate }} IPSA</th>
                    <th scope="col">{{ 'IL_MINIMO' | translate }} {{nemoSasa}}</th>
                    <th scope="col">{{ 'IL_MINIMO' | translate }} IPSA</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td *ngIf="activeLang == 'es'" class="text-right">{{preMax52Semanas | numberFormat}} CLP</td>
                    <td *ngIf="activeLang == 'en'" class="text-right">{{preMax52Semanas | number: '1.2-2'}} CLP</td>
                    <td *ngIf="activeLang == 'es'" class="text-right">{{preMax52SemanasIPSA | numberFormat}} CLP</td>
                    <td *ngIf="activeLang == 'en'" class="text-right">{{preMax52SemanasIPSA | number: '1.2-2'}} CLP</td>
                    <td *ngIf="activeLang == 'es'" class="text-right">{{preMin52Semanas | numberFormat}} CLP</td>
                    <td *ngIf="activeLang == 'en'" class="text-right">{{preMin52Semanas | number: '1.2-2'}} CLP</td>
                    <td *ngIf="activeLang == 'es'" class="text-right">{{preMin52SemanasIPSA | numberFormat}} CLP</td>
                    <td *ngIf="activeLang == 'en'" class="text-right">{{preMin52SemanasIPSA | number: '1.2-2'}} CLP</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div> -->
    <!-- </div>
  </div>
</div> -->
<div class="container-fluid bg-dark px-0">
  <div class="w-100 p-2" style="background-color: #484E52">
  </div>
</div>